import { render, staticRenderFns } from "./IngongdiTable.vue?vue&type=template&id=7a94b0dd&scoped=true&"
import script from "./IngongdiTable.vue?vue&type=script&lang=js&"
export * from "./IngongdiTable.vue?vue&type=script&lang=js&"
import style0 from "./IngongdiTable.vue?vue&type=style&index=0&id=7a94b0dd&scoped=true&lang=css&"
import style1 from "./IngongdiTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a94b0dd",
  null
  
)

export default component.exports